import { useSRS } from 'srs-middleware';
import { useEffect } from 'react';
import { sendPageLoad } from 'utilities/usageStats';

type UseSRSType = typeof useSRS;

/**
 * A wrapper around the `useSRS` hook. It's usage is mostly the same the
 * difference is that it performs some extra slykit specific things.
 */
export const useSlykit: UseSRSType = (...args) => {
	const srsProps = useSRS(...args);

	// Initiate page load usage stat
	useEffect(() => {
		if (srsProps.isReady) {
			sendPageLoad();
		}
	}, [srsProps.isReady]);

	return srsProps;
};
